import React, { ComponentProps, FC, ReactElement } from 'react';

import { Body1Reg, Body2Reg } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { DEFAULT_BORDER_RADIUS, DEFAULT_MARGIN_BOTTOM_BUTTON, DEFAULT_MARGIN_HORIZONTAL_BOTTOM, DEFAULT_MARGIN_TOP_BUTTON, DEFAULT_PADDING_HORIZONTAL_BUTTON, DEFAULT_PADDING_VERTICAL_BUTTON } from './SecondaryButton';
import { Feather } from '@expo/vector-icons';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity } from 'react-native';

const IconComponent = Feather;
type IconName = ComponentProps<typeof IconComponent>['name'];
interface ButtonProps {
  color?: string;
  backgroundColor?: string;
  onPress: () => void;
  label: string;
  width?: number;
  marginBottom?: number;
  marginTop?: number;
  marginHorizontal?: number;
  height? : number;
  paddingVertical? : number;
  paddingHorizontal? : number;
  smallText?: boolean;
  leadingIcon?: ReactElement | IconName,
  trailingIcon?: ReactElement | IconName,
}

const Button: FC<ButtonProps> = ({
  color = COLORS.content['inverse-primary'],
  backgroundColor = COLORS.brand[500],
  onPress,
  label,
  width,
  marginBottom = DEFAULT_MARGIN_BOTTOM_BUTTON,
  marginTop = DEFAULT_MARGIN_TOP_BUTTON,
  marginHorizontal = DEFAULT_MARGIN_HORIZONTAL_BOTTOM,
  height,
  paddingHorizontal = DEFAULT_PADDING_HORIZONTAL_BUTTON,
  paddingVertical = DEFAULT_PADDING_VERTICAL_BUTTON,
  smallText,
  trailingIcon,
  leadingIcon,
}) => {

  return (
    <TouchableOpacity
      style={[
        {
          backgroundColor,
          paddingVertical,
          marginHorizontal,
          borderRadius: DEFAULT_BORDER_RADIUS,
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom,
          marginTop,
          paddingHorizontal,
          display: 'flex',
          flexDirection:'row',
          gap: 10,
          width:'90%',
          maxWidth: 600,
        },
        !!width && { width },
        !!height && {height}
      ]}
      onPress={onPress}
    >
      {typeof leadingIcon === 'string' ? (
        <Feather
          name={leadingIcon as IconName}
          size={SPACING['sp-24']}
          color={color}
        />
      ) : leadingIcon}
      {!!label && (
        <>
          {smallText? (<Body2Reg color={color}>
            {label}
          </Body2Reg>) :(<Body1Reg color={color}>
            {label}
          </Body1Reg>) }
        </>
      )}
      {typeof trailingIcon === 'string' ? (
        <Feather
          name={trailingIcon as IconName}
          size={SPACING['sp-24']}
          color={color}
        />
      ) : trailingIcon}
    </TouchableOpacity>
  );
};

export default Button;
